import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { AuthHttp , JwtHelper} from 'angular2-jwt';
import { Statique } from '../utils/statique';
import { EbInvoice } from "../classes/invoice";
import { SearchCriteriaFreightAudit } from "../utils/SearchCriteriaFreightAudit";
import { EbFavori } from "../classes/favori";
import { EbDemande } from "../classes/demande";
import { InvoiceFichierJoint } from "../classes/InvoiceFichierJoint";


@Injectable()
export class FreightAuditService {
 statique = Statique
  constructor(private http: Http, private authHttp:AuthHttp) { }


  getInvoice(searchCriteriaFreightAudit: SearchCriteriaFreightAudit) {
    return this.authHttp.post(Statique.controllerFreightAudit +  "/get-invoice", searchCriteriaFreightAudit)
      .map((res: Response) => res.json());
  }

  getListInvoice(searchCriteriaFreightAudit: SearchCriteriaFreightAudit) {
    return this.authHttp.post(Statique.controllerFreightAudit + "/get-list-invoice", searchCriteriaFreightAudit)
      .map((res: Response) => res.json());
  }

  changeStatutInvoice(ebInvoice:EbInvoice) {
    return this.authHttp.post(Statique.controllerFreightAudit + "/change-statut-invoice", ebInvoice)
      .map((res: Response) => res.json());
  }

  test() {
    return this.authHttp.get(Statique.controllerFreightAudit + "/test")
      .map((res: Response) => res.json());
  }
  listDestCountry() {
		return this.http
			.get(Statique.controllerStatiqueListe + "/countries")
			.map((res: Response) => res.json());
  }

  ListStatut() {
		return this.http
			.get(Statique.controllerStatiqueListe + "/listStatutFreightAudit")
			.map((res: Response) => res.json());
  }

  ListTypeDemande()
  {
		return this.http
			.get(Statique.controllerStatiqueListe + "/listTypeDemandeFreightAudit")
			.map((res: Response) => res.json());
  }

  ListModeTransport()
  {
		return this.http
			.get(Statique.controllerStatiqueListe + "/listModeTransportFreightAudit")
			.map((res: Response) => res.json());
  }

  getHtmlInvoice(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, applyChargeurIvoicePrice: number,
    applyCarrierIvoicePrice:number, applyChargeurIvoiceNumber:number, applyCarrierIvoiceNumber:number, invoiceMonth:number, invoiceYear:number, invoiceMonthCarrier:number,
     invoiceYearCarrier:number,statutChargeur:number,statutCarrier:number) {
		let style = "font-size: 20px;cursor: pointer;";
		let _type = "checkbox";
    return "<input class='checkbox-invoice' id="+eb_invoice_num+"  type='"+ _type  +"' style='" + style + "' onchange='functions.clickCheckbox(" + eb_invoice_num + ", " +applyChargeurIvoicePrice+ ", " +applyCarrierIvoicePrice+ ", " +applyChargeurIvoiceNumber+ ", " +applyCarrierIvoiceNumber+ ", " +invoiceMonth+ ", " +invoiceYear+ ", " +invoiceMonthCarrier+ ", " +invoiceYearCarrier+ ","+statutChargeur+","+statutCarrier+",event.target)'>";
  }

  getHtmlForCarrierMemo(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, data : any) {
    let style = "font-size: 20px;cursor: pointer;"
    if(data==null){
      return '<input class="form-control1" type="text" value="" style="" onchange="functions.clickAddMemoCarrier('+ eb_invoice_num +',event.target)"/>';
    }
    else{
    return '<input class="form-control1" type="text" value="' + data + '" style="" onchange="functions.clickAddMemoCarrier('+ eb_invoice_num +',event.target)"/>';
  }
  }

  getHtmlForChargeurMemo(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, data : any) {
    let style = "font-size: 20px;cursor: pointer;"
    if(data==null){
      return '<input class="form-control1" type="text" value="" style="" onchange="functions.clickAddMemo('+ eb_invoice_num +',event.target)"/>';
    }
    else{
    return '<input class="form-control1" type="text" value="' + data + '" style="" onchange="functions.clickAddMemo('+ eb_invoice_num +',event.target)"/>';
  }
  }


  getHtmlForChargeurInvoicePrice(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, data : any, priceArraw : number) {
		let style = "font-size: 20px;cursor: pointer;";
    // let _type = "button";
    if(priceArraw==1){
      if(data==null)
    {
      return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
    }
    else{
    return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
  }
}
if(priceArraw==2){
  if(data==null)
{
  return '<span class="receive-arrow><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
}
else{
return '<span class="receive-arrow><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
}
}
    else{
    if(data==null)
    {
      return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/>';
    }
    else{
    return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/>';
  }}
  }
  getHtmlForCarrierInvoicePrice(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, data : any, priceArraw : number) {
			let style = "font-size: 20px;cursor: pointer;";
    // let _type = "button";
    if(priceArraw==1){
    if(data==null)
    {
      return '<span class="receive-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
    }
    else{
    return '<span class="receive-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
  }
}
if(priceArraw==2){
  if(data==null)
  {
    return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
  }
  else{
  return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/></span>';
}
}
else

  if(data==null)
  {
    return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/>';
  }
  else{
  return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoicePrice('+ eb_invoice_num +',event.target)"/>';
}
  }

  getHtmlForChargeurInvoiceNumber(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, data : any, numberArraw : number) {
		let style = "font-size: 20px;cursor: pointer;";
    // let _type = "button";
 if(numberArraw==1){
    if(data==null){
      return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="" onchange="functions.clickApplyChargeurInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';   
  }
  else{
    return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';
  }
}
if(numberArraw==2){
  if(data==null){
    return '<span class="receive-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="" onchange="functions.clickApplyChargeurInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';   
}
else{
  return '<span class="receive-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';
}
}
else{
  if(data==null){
    return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="" onchange="functions.clickApplyChargeurInvoiceNumber('+ eb_invoice_num +',event.target)"/>';   
}
else{
  return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyChargeurInvoiceNumber('+ eb_invoice_num +',event.target)"/>';
}
}

  }
  getHtmlForCarrierInvoiceNumber(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, data : any, numberArraw : number) {
		let style = "font-size: 20px;cursor: pointer;";
    // let _type = "button";
  if(numberArraw==1){
    if(data==null){
      return '<span class="receive-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyCarrierInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';
    }
    else{
    return '<span class="receive-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyCarrierInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';
  }
}
if(numberArraw==2){
  if(data==null){
    return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyCarrierInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';
  }
  else{
  return '<span class="send-arrow"><input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyCarrierInvoiceNumber('+ eb_invoice_num +',event.target)"/></span>';
}
  }
  else{
    if(data==null){
      return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value=" "  onchange="functions.clickApplyCarrierInvoiceNumber('+ eb_invoice_num +',event.target)"/>';
    }
    else{
    return '<input class="carrier-invoice-nbr-'+eb_invoice_num+'" type="text" value="' + data + '"  onchange="functions.clickApplyCarrierInvoiceNumber('+ eb_invoice_num +',event.target)"/>';
  }
  }
  }

  updateStatut(ebInvoice: EbInvoice) {
		return this.authHttp.post(Statique.controllerFreightAudit + "/updateStatutFreightAudit", ebInvoice).map((res: Response) => res.json());

	}

  addOrRemoveFreightAudit(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, applyChargeurIvoicePrice:number,applyCarrierIvoicePrice:number, applyChargeurIvoiceNumber:number, applyCarrierIvoiceNumber:number,
    invoiceMonth:number, invoiceYear:number, invoiceMonthCarrier:number,
    invoiceYearCarrier:number,statutChargeur:number,statutCarrier:number, event: HTMLElement) {
		if (listInvoice.has(eb_invoice_num)) {
			let ebInvoice = listInvoice.get(eb_invoice_num);
      listInvoice.delete(eb_invoice_num);
      console.log( listInvoice);
    
		}
		else {
			let ebInvoice: EbInvoice = new EbInvoice();
      ebInvoice.ebInvoiceNum = eb_invoice_num;
      ebInvoice.applyChargeurIvoicePrice = applyChargeurIvoicePrice,
      ebInvoice.applyCarrierIvoicePrice = applyCarrierIvoicePrice,
      ebInvoice.applyChargeurIvoiceNumber = applyChargeurIvoiceNumber,
      ebInvoice.applyCarrierIvoiceNumber = applyCarrierIvoiceNumber,
      ebInvoice.invoiceMonth = invoiceMonth,
      ebInvoice.invoiceYear = invoiceYear,
      ebInvoice.invoiceMonthCarrier = invoiceMonthCarrier,
      ebInvoice.invoiceYearCarrier = invoiceYearCarrier,
      ebInvoice.statutChargeur = statutChargeur,
      ebInvoice.statutCarrier = statutCarrier,

      listInvoice.set(eb_invoice_num,ebInvoice);
      console.log( listInvoice);
		}

  }

  addMemo(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, event: HTMLElement) {

			let ebInvoice: EbInvoice = new EbInvoice();
      ebInvoice.ebInvoiceNum = eb_invoice_num;
      ebInvoice.memoChageur = event.parentNode['getElementsByTagName']('input')[0].value;
      listInvoice.set(eb_invoice_num,ebInvoice);

      let newList = new Array<EbInvoice>();
      listInvoice.forEach(it => newList.push(it));
      this.updateMemoChageur(newList).subscribe((data) => {
			});
      console.log(listInvoice);


  }


  addMemoCarrier(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, event: HTMLElement) {

    let ebInvoice: EbInvoice = new EbInvoice();
    ebInvoice.ebInvoiceNum = eb_invoice_num;
    ebInvoice.memoCarrier = event.parentNode['getElementsByTagName']('input')[0].value;
    listInvoice.set(eb_invoice_num,ebInvoice);

    let newList = new Array<EbInvoice>();
    listInvoice.forEach(it => newList.push(it));
    this.updateMemoCarrier(newList).subscribe((data) => {
    });
    console.log(listInvoice);


}

applyChargeurInvoicePrice(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, event: HTMLElement) {

  let ebInvoice: EbInvoice = new EbInvoice();
  ebInvoice.ebInvoiceNum = eb_invoice_num;
  ebInvoice.applyChargeurIvoicePrice = event.parentNode['getElementsByTagName']('input')[0].value;
  listInvoice.set(eb_invoice_num,ebInvoice);

  let newList = new Array<EbInvoice>();
  listInvoice.forEach(it => newList.push(it));
  this.applyInvoicePriceChargeur(newList).subscribe((data) => {
  });
  console.log(listInvoice);
}

applyCarrierInvoicePrice(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, event: HTMLElement) {

  let ebInvoice: EbInvoice = new EbInvoice();
  ebInvoice.ebInvoiceNum = eb_invoice_num;
  ebInvoice.applyCarrierIvoicePrice = event.parentNode['getElementsByTagName']('input')[0].value;
  listInvoice.set(eb_invoice_num,ebInvoice);

  let newList = new Array<EbInvoice>();
  listInvoice.forEach(it => newList.push(it));
  this.applyInvoicePriceCarrier(newList).subscribe((data) => {
  });
  console.log(listInvoice);
}

applyChargeurInvoiceNumber(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, event: HTMLElement) {

  let ebInvoice: EbInvoice = new EbInvoice();
  ebInvoice.ebInvoiceNum = eb_invoice_num;
  ebInvoice.applyChargeurIvoiceNumber = event.parentNode['getElementsByTagName']('input')[0].value;
  listInvoice.set(eb_invoice_num,ebInvoice);

  let newList = new Array<EbInvoice>();
  listInvoice.forEach(it => newList.push(it));
  this.applyInvoiceNumberChargeur(newList).subscribe((data) => {
  });
  console.log(listInvoice);
}

applyCarrierInvoiceNumber(listInvoice: Map<number, EbInvoice>, eb_invoice_num: number, event: HTMLElement) {

  let ebInvoice: EbInvoice = new EbInvoice();
  ebInvoice.ebInvoiceNum = eb_invoice_num;
  ebInvoice.applyCarrierIvoiceNumber = event.parentNode['getElementsByTagName']('input')[0].value;
  listInvoice.set(eb_invoice_num,ebInvoice);

  let newList = new Array<EbInvoice>();
  listInvoice.forEach(it => newList.push(it));
  this.applyInvoiceNumberCarrier(newList).subscribe((data) => {
  });
  console.log(listInvoice);
}



  updateMemoChageur(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-memo-chargeur", listInvoice).map((res: Response) => res.json());
  }

  updateMemoCarrier(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-memo-carrier", listInvoice).map((res: Response) => res.json());
  }

  updateFlagChargeur(ebInvoice: EbInvoice){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-flag-chargeur", ebInvoice).map((res: Response) => res.json());
  }

  updateFlagCarrier(ebInvoice: EbInvoice){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-flag-carrier", ebInvoice).map((res: Response) => res.json());
  }

  applyInvoicePriceChargeur(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-applyPrice-chargeur", listInvoice).map((res: Response) => res.json());
  }

  applyInvoicePriceCarrier(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-applyPrice-carrier", listInvoice).map((res: Response) => res.json());
  }

  sharedPrice( listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/shared-invoice-price", listInvoice).map((res: Response) => res.json());
  }

  applyInvoiceNumberChargeur(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-applyNumber-chargeur", listInvoice).map((res: Response) => res.json());
  }

  applyInvoiceNumberCarrier(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-applyNumber-carrier", listInvoice).map((res: Response) => res.json());
  }

  sharedNumber( listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/shared-invoice-number", listInvoice).map((res: Response) => res.json());
  }

  ListInvoiceFichierJoint(eb_invoice_num: number){
    console.log(eb_invoice_num);
    return this.authHttp.post(Statique.controllerFreightAudit + "/getListEbInvoiceByEbInvoiceNum", eb_invoice_num).map((res: Response) => res.json());
  }

  addInvoiceMonthChargeur(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-invoiceMonth-chargeur", listInvoice).map((res: Response) => res.json());
  }

  addInvoiceYearChargeur(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-invoiceYear-chargeur", listInvoice).map((res: Response) => res.json());
  }

  addInvoiceMonthCarrier(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-invoiceMonth-carrier", listInvoice).map((res: Response) => res.json());
  }

  addInvoiceYearCarrier(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-invoiceYear-carrier", listInvoice).map((res: Response) => res.json());
  }

  sharedMonthAndYear(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-share-invoiceYearAndMonth", listInvoice).map((res: Response) => res.json());
  }

  addFacture(ebDemandeNum: number){
    console.log(+ebDemandeNum);
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-ebDemende", ebDemandeNum).map((res: Response) => res.json());
  }

  applyListInvoiceNumberChargeur(listInvoice: Array<EbInvoice>){
   /* let data = {
      "listInvoice": listInvoice,
      "nbr": nbr
    }; */  
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyNumberChargeur", listInvoice).map((res: Response) => res.json());
  }

  deleteFichierJoint(ebInvoiceFichierJoint:number){
    console.log(ebInvoiceFichierJoint);
    return this.authHttp.post(Statique.controllerFreightAudit + "/delete-ebInvoiceFichierJoint", ebInvoiceFichierJoint).map((res: Response) => res.text());
  }

  updateNumberArraw(numberArraw: number,invoiceNum:number){
    let inv = new EbInvoice();
    inv.ebInvoiceNum = invoiceNum;
    inv.numberArraw = numberArraw;  
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-numberArraw", inv).map((res: Response) => res.json());
  }

  updatePriceArraw(priceArraw: number,invoiceNum:number){
    let inv = new EbInvoice();
    inv.ebInvoiceNum = invoiceNum;
    inv.priceArraw = priceArraw;  
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-priceArraw", inv).map((res: Response) => res.json());
  }

 /* updateDateArraw(dateArraw: number,invoiceNum:number){
    let inv = new EbInvoice();
    inv.ebInvoiceNum = invoiceNum;
    inv.dateArraw = dateArraw;  
    return this.authHttp.post(Statique.controllerFreightAudit + "/update-dateArraw", inv).map((res: Response) => res.json());
  }*/
  getDemande(ebDemandeNum: number){
    return this.authHttp.post(Statique.controllerFreightAudit + "/getDemande", ebDemandeNum).map((res: Response) => res.json());
  }

  deleteNbr(ebInvoiceNum: number){
    return this.authHttp.post(Statique.controllerFreightAudit + "/deleteNbr", ebInvoiceNum).map((res: Response) => res.json());
  }

  applyListInvoicePriceChargeur(listInvoice: Array<EbInvoice>){
     
     return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyPriceChargeur", listInvoice).map((res: Response) => res.json());
   }

   applyListInvoiceNumberCarrier(listInvoice: Array<EbInvoice>){
    
     return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyNumberCarrier", listInvoice).map((res: Response) => res.json());
   }

   applyListInvoicePriceCarrier(listInvoice: Array<EbInvoice>){
     
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyPriceCarrier", listInvoice).map((res: Response) => res.json());
  }

  applyListInvoiceMonthChargeur(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyMonthchargeur", listInvoice).map((res: Response) => res.json());
  }

  applyListInvoiceYearChargeur(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyYearchargeur", listInvoice).map((res: Response) => res.json());
  }

  applyListInvoiceMonthCarrier(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyMonthcarrier", listInvoice).map((res: Response) => res.json());
  }

  applyListInvoiceYearCarrier(listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyYearcarrier", listInvoice).map((res: Response) => res.json());
  }

  setTag(ebInvoiceFichierJointNum: number,tag: String){
    let inv = new InvoiceFichierJoint;
    inv.ebInvoiceFichierJointNum = ebInvoiceFichierJointNum;
    inv.tag = tag; 
    return this.authHttp.post(Statique.controllerFreightAudit + "/setTag", inv).map((res: Response) => res.json());
  }

  sharedStatus( listInvoice: Array<EbInvoice>){
    return this.authHttp.post(Statique.controllerFreightAudit + "/shared-status", listInvoice).map((res: Response) => res.json());
  }

  updateStatutChargeur(ebInvoice: EbInvoice) {
	return this.authHttp.post(Statique.controllerFreightAudit + "/updateStatutChargeurFreightAudit", ebInvoice).map((res: Response) => res.json());
  }
  
  updateStatutCarrier(ebInvoice: EbInvoice) {
		return this.authHttp.post(Statique.controllerFreightAudit + "/updateStatutCarrierFreightAudit", ebInvoice).map((res: Response) => res.json());
	}
  
  applyListStatutChargeur(listInvoice: Array<EbInvoice>){
    
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyListStatutChargeur", listInvoice).map((res: Response) => res.json());
  }

  applyListStatutCarrier(listInvoice: Array<EbInvoice>){
    
    return this.authHttp.post(Statique.controllerFreightAudit + "/facture-applyListStatutCarrier", listInvoice).map((res: Response) => res.json());
  }
}




// WEBPACK FOOTER //
// ./src/app/services/freight-audit.service.ts